import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { readMe } from "../providers/api.ts";
import { directus } from "@/providers/directus";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { useBrand } from "@/hooks/useBrand";
import { fetchSecurityState, setupRedirect } from "@/lib/security";

export function ChangePassword() {
  const brand = useBrand();
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function submit(e: React.SyntheticEvent) {
    e.preventDefault();
    setError(null);
    if (password.length < 8) return setError("Use at least 8 characters.");
    if (password !== confirm) return setError("Passwords do not match.");
    setBusy(true);
    try {
      const me: any = await directus.request(readMe({ fields: ["id"] as any }));
      await directus.request(() => ({
        method: "PATCH",
        path: `/portal/users/${me.id}/admin-manage`,
        body: JSON.stringify({ password }),
        headers: { "Content-Type": "application/json" },
      }));
      navigate(setupRedirect(await fetchSecurityState()) ?? "/", { replace: true });
    } catch (err: any) {
      setError(err?.errors?.[0]?.message || "Could not change your password.");
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="login-page min-h-screen grid place-items-center p-6">
      <div className="w-full max-w-[420px]">
        <div className="login-logo-shift flex items-center gap-2.5 mb-6 justify-center">
          <img src={brand.logoUrl} alt={brand.name} className="w-9 h-9 object-contain" />
          <div className="brand-wordmark text-xl">{brand.name}</div>
        </div>
        <form onSubmit={submit} className="login-card rounded-lg p-6 flex flex-col gap-3">
          <h1 className="text-sm font-medium">Choose a new password</h1>
          <p className="text-xs text-muted-foreground">Your initial password was emailed to you. Set your own before continuing.</p>
          <label htmlFor="new-password" className="text-xs text-muted-foreground">
            New password
            <Input id="new-password" type="password" autoComplete="new-password" value={password} onChange={(e) => setPassword(e.target.value)} className="mt-1" />
          </label>
          <label htmlFor="confirm-password" className="text-xs text-muted-foreground">
            Confirm new password
            <Input id="confirm-password" type="password" autoComplete="new-password" value={confirm} onChange={(e) => setConfirm(e.target.value)} className="mt-1" />
          </label>
          {error && <div className="text-xs text-destructive">{error}</div>}
          <Button type="submit" disabled={busy || !password}>{busy ? "Saving..." : "Save password"}</Button>
          <div className="pt-2 border-t border-border text-center">
            <a href="/logout" className="text-xs text-muted-foreground hover:text-foreground underline">
              Sign out / Use a different account
            </a>
          </div>
        </form>
      </div>
    </div>
  );
}
